import { render } from "./analytics.vue?vue&type=template&id=84b6ed84&lang=pug"
import script from "./analytics.vue?vue&type=script&lang=js"
export * from "./analytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__